import { useSelector } from 'react-redux'
import { AppStore } from '../store'
import { CompanyState } from '../store/company/types'
import usuariosService from '../services/usuarios/usuarios-service'
import { UserTypes } from '../constants/enums/UserTypes'

const notPublishUserTypes = [UserTypes.SoloLectura, UserTypes.Invitado]
const notPurchaseUserTypes = [...notPublishUserTypes, UserTypes.Usuario]

export const useCurrentUser = () => {
  const { userData, isLogged, companyData, loading, error } = useSelector<AppStore, CompanyState>(
    ({ companyStore }) => companyStore
  )

  const userType = userData?.tipoUsuario as UserTypes
  const canPublish = !!userType && !notPublishUserTypes.includes(userType)
  const canPurchase = !!userType && !notPurchaseUserTypes.includes(userType)
  const fullBillingData =
    companyData?.razonSocial &&
    companyData?.cantidadEmpleados &&
    companyData?.denominacion &&
    companyData?.condicionIVA &&
    companyData?.cuit &&
    companyData?.email &&
    companyData?.industria &&
    companyData?.descripcion &&
    companyData?.calle &&
    companyData?.provincia &&
    companyData?.numero &&
    companyData?.ciudad &&
    companyData?.codigoPostal
      ? true
      : false

  const consultora = companyData?.consultora

  const superaLimitePublicacion = async () => {
    if (userData && userData.limitePublicaciones >= 0 && userData.idUsuario) {
      const entregas = await usuariosService.getEntrgasAvisosUsuario(userData.idUsuario)
      return userData.limitePublicaciones <= entregas.total
    }
    return false
  }

  return {
    companyData,
    userData,
    userType,
    isLogged,
    consultora,
    canPublish,
    fullBillingData,
    superaLimitePublicacion,
    canPurchase,
    statusFetch: {
      loading,
      error,
    },
  }
}
